import {GridItem} from 'platform/foundation';

import {GermanSpecificFields} from '../../kit/components/GermanSpecificFields';
import {useGetTenantInfo} from '../../kit/hooks/useGetTenantInfo';
import {isTrailerOrSemitrailer} from '../../kit/utils/isTrailerOrSemitrailer';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function VehicleBasicsSubSection() {
  const {isGermanTenant} = useGetTenantInfo();

  return (
    <VFKit.SubSection data-testid="vehicle-basics">
      <VFKit.Group data-testid="make-model">
        <VFKit.MakeSelect />
        <VFKit.ModelSelect />
        <VFKit.ShowWhen
          name="type"
          condition={(type) => !isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
        >
          <VFKit.SimpleTextField name="trim" />
        </VFKit.ShowWhen>
        <VFKit.SimpleTextField name="variant" />
      </VFKit.Group>

      <VFKit.Group data-testid="title" columns={isGermanTenant ? [1, 2, 6] : [1, 2, 4]}>
        <GridItem span={isGermanTenant ? [1, 2, 3] : [1, 2]}>
          <VFKit.TitleField />
        </GridItem>
        {isGermanTenant && (
          <VFKit.Suspense>
            <GermanSpecificFields />
          </VFKit.Suspense>
        )}
      </VFKit.Group>
    </VFKit.SubSection>
  );
}
